import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { ContentfulService } from 'src/app/service/contentful.service';
import { PageLoaderService } from 'src/app/service/page-loader.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-api-reference-mock-screen-page',
  templateUrl: './api-reference-mock-screen-page.component.html',
  styleUrls: ['./api-reference-mock-screen-page.component.scss']
})
export class ApiReferenceMockScreenPageComponent implements OnInit {
  constructor(private contentfulService: ContentfulService, private httpClient: HttpClient, private pageLoaderService: PageLoaderService) { }

  @Input() pageName: string = 'XML Mockup';

  message: string = '';
  activeXML: string = '';
  requestXml: string = '';
  responseXml: string = '';
  otherXmls: any[] = [];

  ngOnInit(): void {
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentWithEntries(query).then((apiReferenceMockScreenItems) => {
      this.mapSection(apiReferenceMockScreenItems);
    });
  }

  mapSection(sectionEntry: Entry<any>[]) {
    sectionEntry.filter((entry) => ModelValidator.isSection(entry));
    this.activeXML = sectionEntry[0].fields['title'] as string;
    sectionEntry.forEach((entry) => {
      this.mapSectionToEntries(entry, entry.fields['xml']);
    });
    this.updateXML(this.activeXML);
  }

  updateXML(xml: string) {
    this.activeXML = xml;
    this.pageLoaderService.addPageLoader(true);
    let filterXml = this.otherXmls.filter((otherXml) => otherXml.title === this.activeXML);
    let response = this.fetchXMLData(filterXml[0].requestUrl, filterXml[0].responseUrl);
    response.subscribe((res) => {
      this.pageLoaderService.addPageLoader(false);
      this.requestXml = res.requestXml;
      this.responseXml = res.responseXml;
    });
  }

  private mapSectionToEntries(entry: Entry, xml: any) {
    try {
      let xmlTitles = entry.fields['title'] as string;
      let requestUrl = xml?.content.filter((xmlContent: { nodeType: string }) => xmlContent.nodeType === 'embedded-asset-block')[0].data?.target?.fields?.file.url;
      let responseUrl = xml?.content.filter((xmlContent: { nodeType: string }) => xmlContent.nodeType === 'embedded-asset-block')[1].data?.target?.fields?.file.url;
      this.otherXmls.push({
        title: xmlTitles,
        requestUrl: requestUrl,
        responseUrl: responseUrl
      });
    } catch (err) {
      throw err;
    }
  }

  private fetchXMLData(requestUrl: string, responseUrl: string): Observable<{ requestXml: string; responseXml: string; message: string }> {
    if (!requestUrl || !responseUrl) {
      return of({ requestXml: '', responseXml: '', message: 'Invalid URLs provided' });
    }

    return forkJoin({
      requestXml: this.httpClient.get(requestUrl, { responseType: 'text' }).pipe(catchError(() => of('unable fetch xml'))),
      responseXml: this.httpClient.get(responseUrl, { responseType: 'text' }).pipe(catchError(() => of('unable fetch xml')))
    }).pipe(
      map(({ requestXml, responseXml }) => ({
        requestXml,
        responseXml,
        message: requestXml && responseXml ? '' : 'Missing XML Data'
      }))
    );
  }
}
